import { createAction, handleActions } from 'redux-actions';

const SET_CATEGORY = 'selectCategory/SET_CATEGORY';
const SET_BTN_CATEGORY = 'listBtnCategory/SET_BTN_CATEGORY';

export const selectCategory = createAction(SET_CATEGORY);
export const listBtnCategory = createAction(SET_BTN_CATEGORY)

const initialState = {
  category: '민사소송절차',
  btnCategory: ''
};

const setCategory = handleActions(
  {
    [SET_CATEGORY]: (state, { payload: category }) => {
      return { ...state, category };
    },
    [SET_BTN_CATEGORY]: (state, { payload: btnCategory }) => {
      return { ...state, btnCategory };
    },
  },
  initialState
);

export default setCategory;
